import { Button, Form, FormProps, Select } from '@pankod/refine-antd';
import { FORM_STATUS } from 'constant';

const Filter: React.FC<{ formProps: FormProps }> = ({ formProps }) => {
  return (
    <Form
      style={{ display: 'flex', gap: '10px' }}
      layout='horizontal'
      {...formProps}
    >
      <Form.Item label='Status' name='status'>
        <Select
          style={{ width: '250px' }}
          allowClear
          defaultValue={FORM_STATUS.QUERY}
          options={[
            {
              label: 'All',
              value: '',
            },
            {
              label: 'Lead',
              value: FORM_STATUS.LEAD,
            },
            {
              label: 'Spam',
              value: FORM_STATUS.SPAM,
            },
            {
              label: 'Query',
              value: FORM_STATUS.QUERY,
            },
          ]}
          placeholder='Status'
        />
      </Form.Item>
      <Form.Item>
        <Button htmlType='submit' type='primary'>
          Filter
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Filter;
